import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NewTransferPage } from '@/features/new-transfer/new-transfer-page.js';

const searchSchema = z.object({ draft: z.string().optional() });

/** حوالة جديدة (transfers.md section 4); `?draft=` resumes a draft. */
export const Route = createFileRoute('/_app/transfers/new')({
  validateSearch: searchSchema,
  component: NewTransferRoute,
});

function NewTransferRoute(): React.JSX.Element {
  const { draft } = Route.useSearch();
  return <NewTransferPage draftId={draft} />;
}
